import React, { useContext, useState } from 'react'
import { DocumentContext } from '../contexts/DocumentContext';
import { UploadedDocumentCards } from './UploadedDocumentCards'
import { UploaderProgressBar } from './UploaderProgressBar'

const DocumentList = ({ docs, index, uploadFileHandler, handleRemoveFile }) => {
    const [percentageUpload, setPercentageUpload, sectionName, setSectionName] = useContext(DocumentContext);
    return (
        <>
            <div className="card mt-3 ">
                <div className="card-header">
                    <strong> {docs['Document_Name']}</strong>
                </div>
                <div className="card-body col-12 col-sm-12 col-md-10 col-lg-4 col-xl-4">
                    <input accept='.png,.jpg,.jpeg,.bmp,.mp4,.webm,.pdf,.doc,.docx,.tif,.tiff,.xls,.xlsx' required id={"fileInput_" + index} className='form-control form-control-sm' type="file" multiple onChange={(e) => uploadFileHandler(e, docs['Document_Name'], index)} />
                </div>

                <div className="card-body col-12 col-sm-12 col-md-10 col-lg-4 col-xl-4">
                    {sectionName === docs['Document_Name'] && (
                        <UploaderProgressBar />
                    )}
                </div>
                {docs && docs['Document_Value'].length > 0 && (
                    <UploadedDocumentCards key={"docvalue_" + index} docs={docs} indexOfFileSection={index} handleRemoveFile={handleRemoveFile} />
                )}
            </div>
        </>

    )
}

export default DocumentList
